import { render, staticRenderFns } from "./WRadio.vue?vue&type=template&id=348a2028&"
import script from "./WRadio.vue?vue&type=script&lang=js&"
export * from "./WRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports